"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatMoney = formatMoney;
exports.formatDesentization = formatDesentization;
exports.formatDate = formatDate;

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.replace");

// 金额转换
function formatMoney(money) {
  var fix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
  return parseFloat(money / scale).toFixed(fix);
} // 数据脱敏


function formatDesentization(_data) {
  var data = _data;
  var regIdCard = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/; // 身份证号码

  var regPhoneNm = /^1[0-9]{10}$/; // 手机号

  var businessLicenseNum = /(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/; // 营业执照

  if (regIdCard.test(data) || regPhoneNm.test(data) || businessLicenseNum.test(data)) {
    // 身份证号 || 手机号  ||  营业执照    前三后四
    data = "".concat(data.substr(0, 3), "****").concat(data.substr(-4));
  } else if (/^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/.test(data)) {
    // 邮箱号码  前二 后以 @ 分割
    data = "".concat(data.substr(0, 2), "****").concat(data.substr(data.indexOf('@')));
  } else if (/^\d{16}|\d{19}$/.test(data)) {
    // 银行卡号  后四位
    data = "****".concat(data.substr(-4));
  } else if (data.indexOf('公司') > -1) {
    // 企业名称  前二后四
    data = "".concat(data.substr(0, 2), "****").concat(data.substr(-4));
  }

  return data;
} // 时间格式化


function formatDate(_date) {
  var _format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm:ss';

  if (!_date) {
    return '';
  }

  var date = new Date(parseInt(_date, 10));
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  var format = _format;

  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, date.getFullYear().toString().substr(4 - RegExp.$1.length));
  }

  Object.keys(o).forEach(function (k) {
    if (new RegExp("(".concat(k, ")")).test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : "00".concat(o[k]).substr(o[k].toString().length));
    }
  });
  return format;
}